import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.modal');
import { OnInit, Input, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-season-modal',
template: templateSource || '',
    styles: [`

/* file: /Users/ijaemun/Documents/Codex/2026-09-30/task/migration-prep/mac-candidate-build/src/app/portal.season.modal/view.scss */
/* src/app/portal.season.modal/view.scss: no such file or directory */`],
})
export class PortalSeasonModalComponent implements OnInit {
    @Input() model: any = null;
    public theme: string = 'modern';

    constructor(@Inject( Service) public service: Service) {
        if (!this.model) this.model = service.modal;
    }

    public async ngOnInit() {
        this.syncTheme();
    }

    @HostListener('window:storage', ['$event'])
    public onStorageChange(event: StorageEvent) {
        if (event.key !== 'ui-theme') return;
        this.syncTheme(event.newValue);
        this.service.render();
    }

    private normalizeTheme(value: any): string {
        return value === 'retro' ? 'retro' : 'modern';
    }

    private syncTheme(value: any = localStorage.getItem('ui-theme')) {
        this.theme = this.normalizeTheme(value);
    }

    public btnColorClass() {
        const buttonStatus = this.model.opts.actionBtn || this.model.opts.status;
        if (buttonStatus == 'warning')
            return 'inline-flex w-full justify-center rounded-md bg-yellow-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-500 sm:ml-3 sm:w-auto';
        if (buttonStatus == 'success')
            return 'inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 sm:ml-3 sm:w-auto';
        return 'inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto';
    }

    public retroBtnStyle() {
        const buttonStatus = this.model.opts.actionBtn || this.model.opts.status;
        if (buttonStatus == 'error')
            return 'padding: 5px 20px; font-size: 12px; font-weight: bold; background: #cc0000; color: #ffffff; border: 1px solid #990000; cursor: pointer;';
        if (buttonStatus == 'warning')
            return 'padding: 5px 20px; font-size: 12px; font-weight: bold; background: #cc9900; color: #ffffff; border: 1px solid #996600; cursor: pointer;';
        return 'padding: 5px 20px; font-size: 12px; font-weight: bold; background: #003366; color: #ffffff; border: 1px solid #001a33; cursor: pointer;';
    }
}

export default PortalSeasonModalComponent;